import { create } from 'zustand'

export const useZustandStoreTemp = create(
    (set) => ({
        v2Open: true,
        setV2Open: (value) => set(() => ({ v2Open: value })),
    }),
);